export const themeBasicColors = [
  "#fff",
  "#fbeaeb",
  "#ffc5dd",
  "#f97591",
  "#f9858b",
  "#fe1694",
  "#d62264",
  "#fff099",
  "#ffe042",
  "#ff8017",
  "#92efdf",
  "#6dd47e",
  "#2e8a57",
  "#73d8ff",
  "#9bcff9",
  "#0080ff",
  "#00154f",
  "#a694ff",
  "#8a2ae3",
  "#4d4d4d",
]
export const themeGradationColors = [
  "linear-gradient(to right, rgb(229, 231, 235), rgb(156, 163, 175), rgb(75, 85, 99))",
  "linear-gradient(rgb(17, 24, 39), rgb(75, 85, 99))",
  "linear-gradient(45deg, #B67B03 0%, #DAAF08 45%, #FEE9A0 70%, #DAAF08 85%, #B67B03 90% 100%)",
  "linear-gradient(45deg, #757575 0%, #9E9E9E 45%, #E8E8E8 70%, #9E9E9E 85%, #757575 90% 100%)",
  "linear-gradient( 135deg, #FD6E6A 10%, #FFC600 100%)",
  "linear-gradient( 135deg, #FFA8A8 10%, #FCFF00 100%)",
  "linear-gradient(45deg, #85FFBD 0%, #FFFB7D 100%)",
  "linear-gradient(to top, #0fd850 0%, #f9f047 100%)",
  "linear-gradient(to right, #BEE615, #15D6E6)",
  "radial-gradient( circle farthest-corner at 10% 20%,  rgba(85,149,27,1) 0%, rgba(183,219,87,1) 90.1% )",
  "linear-gradient(to right, rgb(134, 239, 172), rgb(59, 130, 246), rgb(147, 51, 234))",
  "linear-gradient(to right, rgb(248, 113, 113), rgb(209, 213, 219), rgb(59, 130, 246))",
  "linear-gradient(to right, rgb(147, 197, 253), rgb(187, 247, 208), rgb(253, 224, 71))",
  "linear-gradient(to right, rgb(249, 168, 212), rgb(216, 180, 254), rgb(129, 140, 248))",
  "linear-gradient(to right, rgb(254, 202, 202), rgb(252, 165, 165), rgb(254, 240, 138))",
  "linear-gradient(to right, rgb(254, 240, 138), rgb(251, 207, 232), rgb(244, 114, 182))",
  "linear-gradient(90deg, #FF9A8B 0%, #FF6A88 55%, #FF99AC 100%)",
  "linear-gradient(to right, rgb(254, 202, 202), rgb(220, 38, 38))",
  "linear-gradient(to right, rgb(244, 114, 182), rgb(219, 39, 119))",
  "linear-gradient(to right, rgb(236, 72, 153), rgb(239, 68, 68), rgb(234, 179, 8))",
  "linear-gradient(yellow, red)",
  "linear-gradient(to right, rgb(134, 239, 172), rgb(253, 224, 71), rgb(249, 168, 212))",
  "linear-gradient(to right, rgb(165, 180, 252), rgb(192, 132, 252))",
  "linear-gradient(to right, rgb(219, 234, 254), rgb(147, 197, 253), rgb(59, 130, 246))",
  "linear-gradient(45deg, #FA8BFF 0%, #2BD2FF 52%, #2BFF88 90%)",
  "linear-gradient(to right, rgb(251, 113, 133), rgb(217, 70, 239), rgb(99, 102, 241))",
  "linear-gradient( 105.5deg,  rgba(31,212,248,1) 11%, rgba(218,15,183,1) 74.9% )",
  "linear-gradient( 109.6deg,  rgba(48,207,208,1) 11.2%, rgba(51,8,103,1) 92.5% )",
  "radial-gradient( circle farthest-corner at 12.3% 19.3%,  rgba(85,88,218,1) 0%, rgba(95,209,249,1) 100.2% )",
  "linear-gradient( 68.4deg,  rgba(99,251,215,1) -0.4%, rgba(5,222,250,1) 100.2% )",
  "linear-gradient(to right, rgb(96, 165, 250), rgb(52, 211, 153))",
  "linear-gradient( 135deg, #5EFCE8 10%, #736EFE 100%)",
  "linear-gradient(to right, rgb(56, 189, 248), rgb(251, 113, 133), rgb(163, 230, 53))",
  "linear-gradient(90deg, rgba(16, 190, 252, 1) 4%, rgba(129, 188, 243, 1) 13%, rgba(230, 177, 225, 1) 28%, rgba(250, 127, 229, 1) 49%, rgba(255, 125, 125, 1) 67%, rgba(247, 152, 102, 1) 78%, rgba(255, 212, 189, 1) 95%",
  "linear-gradient( 89.9deg,  rgba(255,243,110,1) 16.9%, rgba(30,204,214,1) 55.1%, rgba(5,54,154,1) 90.7% )",
  "linear-gradient( 89.8deg,  rgba(204,156,223,1) 0.3%, rgba(155,219,245,1) 20.4%, rgba(245,183,208,1) 40.2%, rgba(250,186,98,1) 62.9%, rgba(234,238,240,1) 81.9%, rgba(250,245,171,1) 99.2% )",
  "linear-gradient( 102.7deg,  rgba(253,218,255,1) 8.2%, rgba(223,173,252,1) 19.6%, rgba(173,205,252,1) 36.8%, rgba(173,252,244,1) 73.2%, rgba(202,248,208,1) 90.9% )",
  "linear-gradient( 111.5deg,  rgba(249,230,1,1) 9.9%, rgba(249,144,1,1) 19.4%, rgba(255,22,22,1) 29.2%, rgba(255,22,133,1) 37.7%, rgba(255,22,197,1) 47.7%, rgba(232,22,255,1) 53.9%, rgba(162,22,255,1) 60%, rgba(80,22,255,1) 68.8%, rgba(22,104,255,1) 74.2%, rgba(22,168,255,1) 77.6%, rgba(22,255,220,1) 86.7%, rgba(22,255,179,1) 92.5%, rgba(22,255,109,1) 97.1%, rgba(92,255,22,1) 103.5% )",
  "linear-gradient(to top, #fcc5e4 0%, #fda34b 15%, #ff7882 35%, #c8699e 52%, #7046aa 71%, #0c1db8 87%, #020f75 100%)",
  "linear-gradient(to top, #3b41c5 0%, #a981bb 49%, rgb(253, 186, 116) 100%)",
  "linear-gradient(90deg, rgba(226, 207, 255, 1), rgba(251, 253, 191, 1))",
  "linear-gradient(0deg, #FFDEE9 0%, #B5FFFC 100%)",
  "linear-gradient(to right, rgb(199, 210, 254), rgb(254, 202, 202), rgb(254, 249, 195))",
  "linear-gradient( 179.4deg,  rgba(253,240,233,1) 2.2%, rgba(255,194,203,1) 96.2% )",
  "linear-gradient(-20deg, #ddd6f3 0%, #faaca8 100%, #faaca8 100%)",
  "radial-gradient( circle 668px at 2.6% 8.3%,  rgba(219,112,147,1) 0%, rgba(255,228,225,1) 49.5%, rgba(200,130,200,1) 99.4% )",
  "linear-gradient(-225deg, #2CD8D5 0%, #C5C1FF 56%, #FFBAC3 100%)",
  "linear-gradient(to top, #a18cd1 0%, #fbc2eb 100%)",
  "linear-gradient( 109.6deg,  rgba(120,212,234,1) 11.2%, rgba(216,226,253,1) 72.1% )",
  "radial-gradient( circle farthest-corner at 10% 20%,  rgba(235,131,130,1) 0%, rgba(235,131,130,0.75) 38.6%, rgba(211,177,125,0.52) 72.1%, rgba(211,177,125,0.24) 94.7% )",
]
